import { Dictionary } from 'lodash';

import {
  IndicatorByUnitResponse,
  Unit,
  fetchFromOldApi,
} from '~/services/Http';

export const GET_INDICATORS_BY_UNIT_SWR_KEY = 'getIndicatorsByUnit';
export const getIndicatorsByUnit = async (
  unitId: number,
): Promise<Dictionary<IndicatorByUnitResponse[]>> => {
  return await (
    await fetchFromOldApi(`/json/solaintel/indicator/summary/unit/${unitId}`)
  ).json();
};

export const GET_UNITS_SWR_KEY = 'getUnits';
export const getUnits = async (includeInactive: boolean): Promise<Unit[]> => {
  return await (
    await fetchFromOldApi(`/json/org/unit?includeInactive=${includeInactive}`)
  ).json();
};
